import type { NumbersCollabs } from "redux-context/collabs";

export const hasExistingCollab = (
  loading?: boolean,
  numbers?: NumbersCollabs,
) => !loading && (numbers?.totalCollabs || 0) > 0;
